<template>
    <UContainer v-if="withContainer">
        <slot></slot>
    </UContainer>
    <template v-else>
        <slot></slot>
    </template>
</template>

<script setup lang="ts">
defineProps<{
    withContainer: boolean
}>()
</script>
